// src/features/common/screens/NotFoundPage.tsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";

const PRIMARY = "#1F3A93";

/** Force-visible quiet style for outline buttons on white/glass rows */
const QUIET =
  "!bg-white !text-gray-900 !border-black/10 border ring-1 ring-black/5 shadow-sm rounded-xl hover:!bg-gray-50 active:!bg-gray-50";

export default function NotFoundPage() {
  const navigate = useNavigate();
  const { t } = useLanguage();

  function goHome() {
    const role = sessionStorage.getItem("role");
    switch (role) {
      case "SUPER_ADMIN":
        navigate("/super-admin");
        break;
      case "HOA_ADMIN":
        navigate("/hoa-admin");
        break;
      case "RESIDENT":
        navigate("/resident");
        break;
      default:
        navigate("/login");
    }
  }

  return (
    <div className="relative min-h-screen flex items-center justify-center px-4">
      {/* soft ambient background like the rest of the app */}
      <div className="pointer-events-none absolute inset-0 -z-10 bg-[radial-gradient(1200px_600px_at_50%_-10%,rgba(31,58,147,0.06),transparent_60%)]" />

      <Card
        variant="glass"
        className="w-full max-w-md rounded-3xl p-8 text-center"
      >
        <div className="space-y-3">
          <div className="text-[64px] leading-none font-extrabold tracking-tight text-gray-900">
            404
          </div>
          <h2 className="text-xl font-semibold text-gray-900">
            {t("notFound.title")}
          </h2>
          <p className="text-sm text-gray-600">
            {t("notFound.subtitle")}
          </p>
        </div>

        <div className="mt-6 flex flex-col sm:flex-row gap-3 justify-center">
          {/* Primary (blue) button → white text */}
          <Button
            onClick={goHome}
            className="rounded-xl px-5 py-2.5 font-medium text-white shadow-lg hover:shadow-xl transition"
            style={{ backgroundColor: PRIMARY }}
          >
            {t("notFound.goHome")}
          </Button>

          {/* Quiet/secondary button → white bg + black text */}
          <Button
            variant="outline"
            onClick={() => window.history.back()}
            className={`h-8 px-3 ${QUIET}`}
          >
            {t("notFound.goBack")}
          </Button>
        </div>
      </Card>
    </div>
  );
}
